export default __webpack_public_path__ + "static/media/logo-serprobots-big.74406209.png";